import { Capacitor } from '@capacitor/core'

// Store prices are allowed on the installed app. The purchase itself is
// StoreKit or Play Billing. The app does not link to the website checkout.
// ILS prices are the same on every platform (Apple, Google, and the website).
export const canShowPricing = true

export function isNativeApp() {
  return Capacitor.isNativePlatform()
}
